/**
 * Applications Grid Component
 * Displays all application cards in a responsive grid
 */

import { Grid } from "@mui/material";
import AppCard from "./AppCard";

const AppsGrid = ({ cards, onExternalAppClick }) => {
  return (
    <Grid container spacing={3}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={6} md={3} key={card.id || card.path || index}>
          <AppCard
            card={card}
            index={index}
            onExternalClick={onExternalAppClick}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AppsGrid;
